import Clipboard from 'clipboard';

/**
 * 在用户手动触发的DOM事件函数中调用此方法可复制指定的字符串到剪贴板
 * @param params { text:要复制的字符串, event:Event对象, success?:成功回调函数(可选), error?:失败回调函数(可选) }
 * @example document.querySelector('#btnCopy').addEventListener('click', event => { copy({ text:'复制', event }) })
 */
export default function (params: { text: string; event: any; success?: any; error?: any }){
	const clipboard = new Clipboard(params.event.target, {
		text: () => params.text,
	});
	clipboard.on('success', () => {
		params.success && params.success();
		clipboard.off('error');
		clipboard.off('success');
		clipboard.destroy();
	});
	clipboard.on('error', () => {
		params.error && params.error();
		clipboard.off('error');
		clipboard.off('success');
		clipboard.destroy();
	});
	clipboard.onClick(event);
}
